export default {
	chatItem: {
		error: 'Something went wrong. Please try again or come back later',
		loading: 'Analysing prompt and searching vehicles',
		timeout: 'Your results are taking longer than expected. Please refresh the page or try your search again.',
	},
	conversationLoadError: {
		description: `We couldn't load your previous conversations. Please try again later`,
		title: 'Failed to load conversations',
	},
	exampleChats: {
		title: 'Example chats',
	},
	inputPlaceholder: 'What vehicles are you looking for?',
	loading: 'Checking for previous searches',
	messageLoadError: {
		description: `We couldn't load your previous messages. Please try again later`,
		title: 'Failed to load messages',
	},
	placeholder0: 'Not quite right? Keep searching',
	sendButtonText: 'Send query',
	sendQueryError: {
		description: 'Failed to send request. Please try again later',
		title: 'Something went wrong',
	},
	sidebar: {
		chatsHeading: 'Chats',
		emptyState: 'No chats yet',
		loading: 'Loading conversations…',
		newChat: 'New chat',
		startNewChat: 'Start new chat',
		title: 'Chats',
	},
	subtitle:
		'Speed up the time it takes to find the stock you really want by searching for more than just filterable items.',
	thinkingSteps: {
		step1: 'Analysing your prompt',
		step2: 'Searching Live sale vehicles',
		step3: 'Collating your vehicles',
	},
	title: "Find the vehicles you're looking for",
};
